import { render, staticRenderFns } from "./dev_chating.vue?vue&type=template&id=8f7c846c&scoped=true&"
import script from "./dev_chating.vue?vue&type=script&lang=js&"
export * from "./dev_chating.vue?vue&type=script&lang=js&"
import style0 from "./dev_chating.vue?vue&type=style&index=0&id=8f7c846c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7c846c",
  null
  
)

export default component.exports